// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1y7hJ","label":"SetPasswdForm_label__tGgCA"};